import TYPES from '../../types';

// Domain
import {
  IncomeBehaviorInFollowingYearRepository,
} from '@/modules/flagship/catalogs/income-behavior-in-following-year/domain/repositories/income-behavior-in-following-year-repository';
import {
  IncomeBehaviorInFollowingYearEntity,
} from '@/modules/flagship/catalogs/income-behavior-in-following-year/domain/entities/income-behavior-in-following-year-entity';
import {
  IncomeBehaviorInFollowingYearStateManager,
} from '@/modules/flagship/catalogs/income-behavior-in-following-year/domain/state/income-behavior-in-following-year-state-manager';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import Query from '@/modules/shared/domain/use-cases/query';

@Injectable()
export default class GetIncomeBehaviorInFollowingYearQuery
  extends Query<Promise<Array<IncomeBehaviorInFollowingYearEntity>>> {
  @Inject(TYPES.INCOME_BEHAVIOR_IN_FOLLOWING_YEAR_REPOSITORY)
  private readonly repository!: IncomeBehaviorInFollowingYearRepository;

  @Inject(TYPES.INCOME_BEHAVIOR_IN_FOLLOWING_YEAR_STATE_MANAGER)
  private readonly state_manager!: IncomeBehaviorInFollowingYearStateManager;

  internalExecute(): Promise<Array<IncomeBehaviorInFollowingYearEntity>> {
    return new Promise((resolve, reject) => {
      if (this.state_manager.state.loaded) {
        resolve(this.state_manager.state.items);
      } else {
        this.repository.execute()
          .then((items) => {
            this.state_manager.patch({ items, loaded: true });
            resolve(items);
          })
          .catch(reject);
      }
    });
  }
}
